import { render, staticRenderFns } from "./selectoptions.vue?vue&type=template&id=2ba15fa4&"
import script from "./selectoptions.js?vue&type=script&lang=js&"
export * from "./selectoptions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba15fa4')) {
      api.createRecord('2ba15fa4', component.options)
    } else {
      api.reload('2ba15fa4', component.options)
    }
    module.hot.accept("./selectoptions.vue?vue&type=template&id=2ba15fa4&", function () {
      api.rerender('2ba15fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/selectoptions.vue"
export default component.exports